import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowSquareLeft = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowSquareLeft" data-sentry-source-file="ArrowSquareLeft.tsx">
            <path fill='currentColor' d='M13.26 16.28c-.19 0-.38-.07-.53-.22L9.2 12.53a.754.754 0 0 1 0-1.06l3.53-3.53c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-3 3 3 3c.29.29.29.77 0 1.06a.7.7 0 0 1-.53.22' data-sentry-element="path" data-sentry-source-file="ArrowSquareLeft.tsx" />
        </svg>;
};
export default SvgArrowSquareLeft;